import { jsx as _jsx } from "react/jsx-runtime";
import { isEmptyArray } from '@vista/omnichannel-components-domain';
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { Tag } from '../tag/tag';
const b = bemClassBuilder('v-tag-list');
export const TagList = observer(props => {
    const { tags, onTagClicked, onTagButtonClicked, className } = props;
    if (isEmptyArray(tags))
        return null;
    return (_jsx("ul", Object.assign({ className: b.block(undefined, className) }, { children: tags.map((tag, i) => (_jsx("li", Object.assign({ className: b.element('tag') }, { children: _jsx(Tag, Object.assign({}, tag, { onClick: onTagClicked, onButtonClick: onTagButtonClicked })) }), tag.id || i))) })));
});
TagList.displayName = 'Tags';
